import React from "react";
import { IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { ICellRendererParams } from "ag-grid-community";

import { AnalystUser } from "../types";

interface EditActionContext {
  onEditAnalyst: (analyst: AnalystUser) => void;
}

export const EditActionCellRenderer: React.FC<
  ICellRendererParams<AnalystUser>
> = (params) => {
  const context = params.context as EditActionContext | undefined;

  const handleClick = (): void => {
    if (!context?.onEditAnalyst || !params.data) return;
    context.onEditAnalyst(params.data);
  };

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      color="primary"
      sx={{ color: "text.primary" }}
    >
      <EditIcon />
    </IconButton>
  );
};
